import { render } from "./DWidgetBrand.vue?vue&type=template&id=5cc6c632"
import script from "./DWidgetBrand.vue?vue&type=script&lang=js"
export * from "./DWidgetBrand.vue?vue&type=script&lang=js"

import "./DWidgetBrand.vue?vue&type=style&index=0&id=5cc6c632&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__